import { useId, useState, useMemo, Fragment } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { ToggleGroup, ChevronIcon } from '@ui/kit';
import { sequenceTileInput } from '@utils/component-framework';
import { SizeTransition } from '@utils/react';
import { useOpgavekompleksetEntry } from '../../../../../state/hook.entry.js';
import { useTaskContext, TaskContext } from '../../../context.js';
import { SequenceInput } from '../input.content.js';
import { orderInputs } from '../util.order-inputs.js';
import { root, toggle, transitionWrapper, crossfadeDurationMs, wrapper, container, chevron } from './container.facit.mobile.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function MobileVerticalFacitContainer(props) {
  const context = useTaskContext();
  const id = useId();
  const [tab, setTab] = useState("answer");
  const inputEntries = useOpgavekompleksetEntry({
    select: entry => Object.entries(entry?.data.tasks[props.taskEntryKey]?.details ?? {}).map(([key, value]) => {
      const typedValue = sequenceTileInput.entry.asTypeSafe(value);
      if (typedValue) {
        return {
          nodeId: key,
          ...typedValue
        };
      }
    }).filter(it => !!it)
  });
  const userOrderedInputs = useMemo(() => orderInputs(props.task.content, inputEntries), [inputEntries, props.task.content]);
  return /*#__PURE__*/jsxs("div", {
    className: root,
    "data-tab": tab,
    children: [context === "facit" && /*#__PURE__*/jsx(ToggleGroup, {
      className: toggle,
      baseId: id,
      label: "V\xE6lg visningstilstand",
      onTabClick: setTab,
      selectedTabId: tab,
      tabs: [{
        id: "answer",
        title: "Mit svar"
      }, {
        id: "facit",
        title: "Rigtigt svar"
      }]
    }), /*#__PURE__*/jsxs(TransitionGroup, {
      component: "div",
      className: transitionWrapper,
      children: [tab === "answer" && /*#__PURE__*/jsx(SizeTransition, {
        axis: "vertical",
        swappable: true,
        classNames: wrapper,
        timeout: crossfadeDurationMs,
        children: ref => /*#__PURE__*/jsx("div", {
          ref: ref,
          id: `${id}-panel-answer`,
          className: wrapper,
          "data-theme": "input",
          children: /*#__PURE__*/jsx("div", {
            className: container,
            children: userOrderedInputs.map(input => /*#__PURE__*/jsxs(Fragment, {
              children: [/*#__PURE__*/jsx(SequenceInput, {
                node: input,
                taskEntryKey: props.taskEntryKey
              }), /*#__PURE__*/jsx(ChevronIcon, {
                className: chevron,
                height: 8,
                strokeWidth: 3
              })]
            }, input.id))
          })
        })
      }, "answer"), tab === "facit" && /*#__PURE__*/jsx(SizeTransition, {
        axis: "vertical",
        swappable: true,
        classNames: wrapper,
        timeout: crossfadeDurationMs,
        children: ref => /*#__PURE__*/jsx("div", {
          ref: ref,
          id: `${id}-panel-facit`,
          className: wrapper,
          "data-theme": "facit",
          children: /*#__PURE__*/jsx("div", {
            className: container,
            children: /*#__PURE__*/jsx(TaskContext.Provider, {
              value: "readonly",
              children: props.task.content.map(input => /*#__PURE__*/jsxs(Fragment, {
                children: [/*#__PURE__*/jsx(SequenceInput, {
                  node: input,
                  taskEntryKey: props.taskEntryKey
                }), /*#__PURE__*/jsx(ChevronIcon, {
                  className: chevron,
                  height: 8,
                  strokeWidth: 3
                })]
              }, input.id))
            })
          })
        })
      }, "facit")]
    })]
  });
}

export { MobileVerticalFacitContainer };
//# sourceMappingURL=container.facit.mobile.js.map
